export default "__VITE_PUBLIC_ASSET__ca8cfa38__"